/**
 * Locale registry for voice reference reading samples.
 * Future languages: add canvas.json keys only — no component branches.
 */
export const VOICE_REFERENCE_READING_SAMPLE_LOCALES = ['zh-CN', 'en-US'] as const

export type VoiceReferenceReadingLocale = (typeof VOICE_REFERENCE_READING_SAMPLE_LOCALES)[number]

export function resolveVoiceReferenceReadingLocale(language: string): VoiceReferenceReadingLocale {
  if (language.startsWith('zh')) return 'zh-CN'
  return 'en-US'
}

export const VOICE_REFERENCE_READING_I18N_KEYS = {
  sampleText: 'voiceTemplate.referenceCapture.readingSample.text',
  sampleHint: 'voiceTemplate.referenceCapture.readingSample.hint',
  sampleNaturalHint: 'voiceTemplate.referenceCapture.readingSample.naturalHint',
  freeformHint: 'voiceTemplate.referenceCapture.readingSample.freeformHint',
} as const
